import api from "../api/api";
import { getVideoToTextListProps, getVideoToTextListResponse } from "./props";

export const getVideoToTextListApi = async (data: getVideoToTextListProps) => {
  return await api.post<getVideoToTextListResponse>(
    "/api/video/summarize",
    data
  );
};
